import { Component, AfterViewInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators, FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { ViewController } from 'ionic-angular';

import { SessionService } from '../../services/session.service';
import { RecommendationService } from '../../services/recommendation.service';
import { RegionService } from '../../services/region.service';
import { SharedConstants } from '../../services/shared/shared-constants';
import { NetworkStatusService } from '../../services/network-status.service';
import { UtilityService } from '../../services/utility.service';

interface FormFormControlObject {
  [key: string]: FormControl;
}

@Component({
  selector: 'sms-customer-page',
  templateUrl: 'sms-customer.html',
})
export class SMSCustomerPage implements AfterViewInit {
  @ViewChild('pdfBody', { read: ViewContainerRef })
  pdfBody: ViewContainerRef;

  private customerFormControlObject: FormFormControlObject;

  customerFormObject: FormGroup;
  formIsReady: boolean;
  wait: boolean;
  networkOnline: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private recommendationService: RecommendationService,
    public regionService: RegionService,
    public sessionService: SessionService,
    public viewCtrl: ViewController,
    public networkService: NetworkStatusService
  ) {
    this.networkService.online$.subscribe((res) => {
      this.networkOnline = res;
      if (!this.networkOnline && this.wait) {
        this.viewCtrl.dismiss(false);
      }
    });
  }

  close(): void {
    this.viewCtrl.dismiss();
  }

  send(): void {
    console.log('send sms');
    this.wait = true;
    const pdfBody: string = this.pdfBody.element.nativeElement.innerHTML;
    this.recommendationService.sms(pdfBody).subscribe(
      () => {
        this.wait = false;
        this.viewCtrl.dismiss(true);
      },
      (err: any) => {
        this.wait = false;
        this.viewCtrl.dismiss(false);
      }
    );
  }

  generateFormControlObj(): FormFormControlObject {
    const utilityService = new UtilityService();

    const customerFormControlObject: FormFormControlObject = {};

    function buildFormControl(field: any): void {
      const validators: any[] = [];
      if (field.required) {
        validators.push(utilityService.validateNumber);
      }
      customerFormControlObject[field.name] = new FormControl(field.model, validators);
    }

    buildFormControl(this.sessionService.phone);
    customerFormControlObject[this.sessionService.phone.name].valueChanges.subscribe((value: number) => {
      this.sessionService.phone.model = value;
      // this.updateForm();
    });

    customerFormControlObject[this.sessionService.phone.name].setValue(this.sessionService[this.sessionService.phone.name].model);

    return customerFormControlObject;
  }

  private buildForm(): void {
    this.customerFormControlObject = this.generateFormControlObj();
    this.customerFormObject = this.formBuilder.group(this.customerFormControlObject);

    setTimeout(() => {
      this.formIsReady = true;
    }, 300);
  }

  submit(formValues: any, valid: boolean): void {
    console.log(formValues, valid);
  }

  navigateToTermsPage() {
    window.open(`${window.location.origin}/#/SMSTerms`, '_blank');
  }

  ngAfterViewInit(): void {
    this.buildForm();
  }
}



// WEBPACK FOOTER //
// ./src/pages/sms-customer/sms-customer.ts